import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GuidDictionaryItem } from '../../../../api/api-reference';

@Component({
  selector: 'app-dropdown-filter',
  standalone: true,
  imports: [
    TranslateModule, CommonModule,
  ],
  templateUrl: './dropdown-filter.component.html',
  styleUrl: './dropdown-filter.component.scss'
})
export class DropdownFilterComponent implements OnChanges {
  @Input() items: GuidDictionaryItem[] = [];
  @Input() title: string = '';
  @Input() includeAll: boolean = true;
  @Input() selectedValue: string | undefined;
  @Output() close = new EventEmitter<string>();

  isStatusOpen = false;
  selectedOption: string = 'ALL';
  sortingTypeDictionary: GuidDictionaryItem[] = [];

  ngOnChanges(): void {
    this.sortingTypeDictionary = this.includeAll
      ? [new GuidDictionaryItem({ value: '', name: 'ALL' }), ...this.items]
      : [...this.items];

    if (this.selectedValue === undefined || this.selectedValue === '') {
      this.selectedOption = 'ALL';
    }
  }

  toggleModal(option?: GuidDictionaryItem) {
    if (option) {
      this.selectedOption = option.name ?? 'ALL';
      this.close.emit(option.value);
      this.isStatusOpen = false;
      return;
    }
    this.isStatusOpen = !this.isStatusOpen;
  }

  closeModal() {
    this.isStatusOpen = false;
  }
}
